import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'react-redux';
import * as employeeApi from '../../../lib/api/employee';

import {  listResume } from '../../../modules/empModule/empPersonal';
import ResumeForm from '../../../components/employeemng/personal/ResumeForm';


const ResumeFormContainer = ({ employee }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    attrVal1: '',
    attrVal2: '',
    attrVal3: '',
    attrVal4: '',
    attrVal5: '',
    attrVal6: '',
  };

  const validationSchema = yup.object({
    attrVal1: yup.string('').required('재직회사명을 입력하세요'),
    attrVal2: yup.string().required('부서명을 입력하세요'),
    attrVal3: yup.string().required('직책을 입력하세요'),
    attrVal4: yup.string().required('역할을 입력하세요'),
    attrVal5: yup.string().required('재직기간 입력하세요'),
    attrVal6: yup.string().nullable(''),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        usrUuid: employee.usrUuid,
        infoTyp: 'RESUME_INF',
        attrVal1: values.attrVal1,
        attrVal2: values.attrVal2,
        attrVal3: values.attrVal3,
        attrVal4: values.attrVal4,
        attrVal5: values.attrVal5,
        attrVal6: values.attrVal6,
      };

      //console.log(JSON.stringify(dataToSubmit),'dataToSubmit');

      try {
        const response = await employeeApi.addResumeByEmp(dataToSubmit);
        if (response.data) {
          dispatch(
            listResume({
              id: employee.usrUuid,
              infoTyp: 'RESUME_INF',
            }),
          );
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <ResumeForm formik={formik} />;
};

export default ResumeFormContainer;
